import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

const Confirmation = () => {
  const router = useRouter();
  useEffect(() => {
    router.push('/');
  }, []);
  return (
    <div></div>
  );
};

export default Confirmation;
